import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company, EmployeeCode } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function departmentsPunch() {
    let url = 'punch/departments?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let departments = response.departments;

                //saveDepartments(departments);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortDepartment(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.descriptionE.toLowerCase() : a.descriptionF.toLowerCase()
        const nameB = IsEnglish() ? b.descriptionE.toLowerCase() : b.descriptionF.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortDepartmentByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.departmentCode
        const nameB = b.departmentCode
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

function saveDepartments(config) {
    localStorage.setItem('punchDepartments', JSON.stringify(config));
}